import { FC } from 'react'
import { useField } from 'formik'

import style from '@src/pages/TerminationAgreement/TerminationAgreement.module.scss'
import { Button } from '@src/components/Button/Button'
import { CheckBoxFormik } from '@src/components/common/CheckBoxFormik/CheckBoxFormik'
import { TextAreaFormik } from '@src/components/common/TextAreaFormik/TextAreaFormik'

type FirstStepProps = {
  checkBoxQuestions: Question[]
  onClick?: any
  step?: any
}
interface Question {
  id: string
  // checked: boolean
  name: string
  description: string
}

export const FirstStep: FC<FirstStepProps> = ({
  step, onClick, checkBoxQuestions,
}) => {
  const [{ onChange, value }] = useField('checkBoxQuestion')

  return (
    <div className={style.stepFirstContainer}>
      <div className={style.step}>
        Шаг 1/2
      </div>
      <h2 className={style.mainTitle}>Укажите причину расторжения действующего договора</h2>
      <div className={style.description}>
        Выберите причину расторжения и оставьте Ваш комментарий с пояснением.
      </div>
      <div className={style.checkBoxContainer}>
        {checkBoxQuestions.map((item) => (
          <CheckBoxFormik
            key={item.id}
            name="checkBoxQuestion"
            label={item.description}
            value={item.id}
            className={style.item}
            type="radio"
            onChange={onChange}
            checked={value === item.id}
          />
        ))}
      </div>
      <div className={style.textAreaBox}>
        <TextAreaFormik className={style.textareaSize} name="comment" placeholder="Дополнительное пояснение" />
      </div>
      <div className={style.btnBlock}>
        <Button onClickFunc={() => onClick(step + 1)} className={style.btnSize}>Следующий шаг</Button>
      </div>
    </div>
  )
}
